import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface HoloStatBadgeProps {
  icon?: ReactNode;
  label: string;
  value: string | number;
  className?: string;
  variant?: "primary" | "secondary" | "accent" | "muted";
}

const variantStyles = {
  primary: "border-primary/25 bg-primary/8 text-primary",
  secondary: "border-secondary/25 bg-secondary/8 text-secondary",
  accent: "border-accent/25 bg-accent/8 text-accent",
  muted: "border-border bg-muted/30 text-muted-foreground",
};

const HoloStatBadge = ({ icon, label, value, className, variant = "primary" }: HoloStatBadgeProps) => (
  <div className={cn(
    "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-semibold backdrop-blur-sm",
    variantStyles[variant],
    className
  )}>
    {icon}
    <span className="opacity-70 font-normal">{label}</span>
    <span>{value}</span>
  </div>
);

export default HoloStatBadge;
